import { useEffect } from 'react';

const Layout = ({ children }) => {

  useEffect(() => {
    document.body.classList.add('h-100');
    const root = document.getElementById('root');
    if (root) {
      root.classList.add('h-100');
    }
    return () => {
      document.body.classList.remove('h-100');
      if (root) {
        root.classList.remove('h-100');
      }
    };
  }, []);
      return (
          <>{children}</>
      );
}
export default Layout;
